import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import Tabs from '../../../common/Tabs'
import { numbersTabs } from '../../shared/numbersTabs';

export default function Numbers(props) {
    const data = {
        url: '/admin/numbers/numbers',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/numbers/numbers/{id}',
        userFilterAdvanced: true,
        userfilter: [
            {
                source: 'number',
                label: 'Number',
                type: 'text',
                default: ''
            },
            {
                source: 'client_id',
                label: 'Client',
                type: 'select',
                default: ''
            },
            {
                source: 'capabilities',
                label: 'Capabilities',
                type: 'select',
                default: ''
            },
            {
                source: 'status',
                label: 'Status',
                type: 'select',
                default: ''
            }
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Number',
                source: 'number',
                type: 'text',
                editable: false,
                default: '',
                placeholder: 'Phone number'
            },
            {
                label: 'Capabilities',
                source: 'capabilities',
                type: 'select',
                editable: false,
                default: '',
                values: {
                    'voice': 'Voice',
                    'sms': 'SMS',
                    'voice_sms': 'Voice + SMS'
                },
                classnames: {
                    'voice': 'label label-info',
                    'sms': 'label label-success',
                    'voice_sms': 'label label-warning'
                }
            },
            {
                label: 'Status',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true,
                values: {
                    true: 'Active',
                    false: 'Inactive'
                },
                classnames: {
                    true: 'label label-success',
                    false: 'label label-danger'
                }
            },
            {
                label: 'Type',
                source: 'type',
                type: 'text',
                editable: false,
                default: '',
                placeholder: 'Number type'
            },
            {
                label: 'Country',
                source: 'country',
                type: 'text',
                editable: false,
                default: '',
                placeholder: 'Country code'
            },
            {
                label: 'Client',
                source: 'client_id',
                type: 'select',
                editable: false,
                default: '',
                placeholder: 'Client ID'
            },
            {
                label: 'Created',
                source: 'created_at',
                type: 'datetime',
                editable: false,
                default: ''
            },
            {
                label: 'Delete',
                type: 'delete',
            }
        ]
    }
    
    return (
        <Panel title="Numbers">
            <>            
                <Tabs tabs={numbersTabs} />
                <DataResource
                    addButtonText="Create New Number"
                    addButtonType="link"
                    addButtonLink="/numbers/numbers/create"
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    );
}